import React from 'react';
import { Clock, Book, User, MapPin } from 'lucide-react';

const JOURS_SEMAINE = [
  { id: 1, libelle: 'Lundi', color: 'slate' },
  { id: 2, libelle: 'Mardi', color: 'emerald' },
  { id: 3, libelle: 'Mercredi', color: 'amber' },
  { id: 4, libelle: 'Jeudi', color: 'violet' },
  { id: 5, libelle: 'Vendredi', color: 'rose' },
  { id: 6, libelle: 'Samedi', color: 'cyan' },
];

const ScheduleTable = ({ emploi, formatTime }) => {
  const getColorClasses = (color) => {
    const colorMap = {
      slate: 'bg-slate-500 hover:bg-slate-600',
      emerald: 'bg-emerald-500 hover:bg-emerald-600',
      amber: 'bg-amber-500 hover:bg-amber-600',
      violet: 'bg-violet-500 hover:bg-violet-600',
      rose: 'bg-rose-500 hover:bg-rose-600',
      cyan: 'bg-cyan-500 hover:bg-cyan-600',
    };
    return colorMap[color] || 'bg-gray-500 hover:bg-gray-600';
  };

  return (
    <div className="print:hidden">
      {JOURS_SEMAINE.map((jour) => {
        const coursDuJour = emploi.cours.filter(c => c.jour === jour.id);
        
        if (coursDuJour.length === 0) return null;
        
        return (
          <div key={jour.id} className="mb-6">
            {/* En-tête du jour avec gradient */}
            <div 
              className={`text-white p-3 rounded-t-lg shadow-lg transition-all duration-200 ${getColorClasses(jour.color)}`}
            >
              <h4 className="text-lg font-bold text-center tracking-wide flex items-center justify-center gap-2">
                <Clock size={20} />
                {jour.libelle}
              </h4>
            </div>

            {/* Tableau des cours pour ce jour */}
            <div className="bg-white rounded-b-lg shadow-lg border border-gray-200 overflow-hidden">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="py-3 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      <Clock size={16} className="inline mr-2" />
                      Horaire
                    </th>
                    <th className="py-3 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      <Book size={16} className="inline mr-2" />
                      Module / Cours
                    </th>
                    <th className="py-3 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      <User size={16} className="inline mr-2" />
                      Enseignant
                    </th>
                    <th className="py-3 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      <MapPin size={16} className="inline mr-2" />
                      Salle
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {coursDuJour.map((cours) => (
                    <tr key={cours.id} className="hover:bg-gray-50 transition-colors duration-150">
                      <td className="py-4 px-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        <div className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-white ${getColorClasses(jour.color)}`}>
                          {formatTime(cours.heure_debut)} - {formatTime(cours.heure_fin)}
                        </div>
                      </td>
                      <td className="py-4 px-4 text-sm text-gray-900">
                        <div className="font-medium">{cours.module?.libelle || 'Non défini'}</div>
                        {cours.type && (
                          <div className="text-xs text-gray-500 mt-1">Type: {cours.type}</div>
                        )}
                      </td>
                      <td className="py-4 px-4 text-sm text-gray-900">
                        <div className="flex items-center">
                          <div className="flex-shrink-0 h-8 w-8">
                            <div className={`h-8 w-8 rounded-full ${getColorClasses(jour.color)} flex items-center justify-center text-white text-xs font-bold`}>
                              {cours.enseignant?.nom_complet?.charAt(0) || 'N'}
                            </div>
                          </div>
                          <div className="ml-3">
                            <div className="font-medium">
                              {cours.enseignant?.nom_complet || 'Non assigné'}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="py-4 px-4 text-sm text-gray-900">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                          {cours.salle?.libelle || 'Non définie'}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ScheduleTable; 